const headerProfileStyle = {
  header_grid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "6px solid #8080801c"
  },
  header_icone: {
    padding: "5px",
    background: "#8080801c",
    borderRadius: "50%"
  }
};

export default headerProfileStyle;
